import React, { useState, useEffect } from 'react';
import './Score.css';
import useSound from './Sound';
import ReplayModal from './ReplayModal';

export default function Score({ score, total, answerHistory, quizSettings, startQuiz, newQuiz }) {
  const [showRecap, setShowRecap] = useState(false);
  const [showReplayModal, setShowReplayModal] = useState(false);
  const percentage = Math.round((score / total) * 100);
  const { playSound } = useSound();

  let feedback;
  let grade;

  if (percentage <= 60) {
    grade = 'fail';
    feedback = 'Keep practicing!';
  } else if (percentage >= 61 && percentage <= 79) {
    grade = 'passing';
    feedback = 'Great! Keep practicing!';
  } else {
    grade = 'amazing';
    feedback = 'AMAZING!!'
  }

  // Play score screen sound once
  useEffect(() => {
    if (percentage <= 60) {
      playSound('fail');
    } else {
      playSound('win');
    }
  }, [percentage]);

  const replay = (settings = quizSettings) => {
    console.log(settings)
    startQuiz({ ...settings })
  };

  return (
    <div className="score-card">
      <h3>Quiz Complete!</h3>
      <h2>You Scored:</h2>
      <h1 className={grade}>{percentage}%</h1>
      <h2>{feedback}</h2>
      <p>{score} out of {total} correct</p>

      <div className="button-group">
        <button className="recap" onClick={() => setShowRecap(!showRecap)}>
          {showRecap ? 'Hide Recap' : 'Review Answers'}
        </button>

        <button className="replay" onClick={() => setShowReplayModal(true)}>
          Play Again
        </button>
      </div>

      {showRecap && (
        <div className="responsive-recap">
          <table className="recap-table">
            <thead>
              <tr>
                <th>Question</th>
                <th>Your Answer</th>
                <th>Correct Answer</th>
              </tr>
            </thead>
            <tbody>
              {answerHistory.map((item, index) => (
                <tr key={index}>
                  <td dangerouslySetInnerHTML={{ __html: item.question }} />
                  <td
                    className={
                      item.selected === item.correct ? 'correct' : 'incorrect'
                    }
                    dangerouslySetInnerHTML={{ __html: item.selected }}
                  />
                  <td dangerouslySetInnerHTML={{ __html: item.correct }} />
                </tr>
              ))}
            </tbody>
          </table>
        </div>  
      )}

      <ReplayModal
        isOpen={showReplayModal}
        onClose={() => setShowReplayModal(false)}
        onReplaySame={() => {
          setShowReplayModal(false);
          replay();
        }}
        onNewQuiz={() =>{
          setShowReplayModal(false);
          newQuiz();
        }}
      />
    </div>
  );
}